// @flow
import type { ChildrenArray, Element } from 'react';
import { usePropsValidation } from '../validation/runtime-checks/index.js';
import { types as t } from '../validation/runtime-checks/prop-spec.js';
import GlossaryTermLocale from './glossaryLocale.js';

export default function GlossaryTerm(props: {|
  id: string,
  subtopicReference: number[],
  children: ChildrenArray<Element<typeof GlossaryTermLocale>>,
|}) {
  const { failedValidation } = usePropsValidation(props, GlossaryTerm);
  if (failedValidation) return null;

  return props.children;
}

GlossaryTerm.spec = {
  id: t.string,
  subtopicReference: t.arrayOf(t.number),
  children: t.childrenArray(t.elementType(GlossaryTermLocale)),
};
